// src/pages/touchPoints/timeline/bridge.js
// "Bridge"/knockout rendering for crossing connector lines. Convention: a
// horizontal segment passes OVER a vertical one, so we break (gap) the vertical
// wherever a horizontal crosses it and draw the horizontal straight through.
// Breaking the under-line (rather than painting a casing) keeps the effect
// independent of whatever background — band tint, panel — sits behind the cross.

// Pull every horizontal segment ("over" lines) out of a set of orthogonal point paths.
export function collectHorizontals(paths) {
  const hs = [];
  paths.forEach((pts) => {
    for (let i = 0; i < pts.length - 1; i += 1) {
      const [x1, y1] = pts[i]; const [x2, y2] = pts[i + 1];
      if (y1 === y2) hs.push({ y: y1, xmin: Math.min(x1, x2), xmax: Math.max(x1, x2) });
    }
  });
  return hs;
}

// y-positions where horizontals cross the vertical x=segX over [ya,yb], with a
// gap-margin so a crossing never lands on the segment's own endpoints/corners.
export function crossingYs(segX, ya, yb, horizontals, gap) {
  const lo = Math.min(ya, yb); const hi = Math.max(ya, yb);
  const ys = horizontals
    .filter((h) => h.xmin < segX && segX < h.xmax && lo + gap < h.y && h.y < hi - gap)
    .map((h) => h.y)
    .sort((a, b) => a - b);
  // merge crossings closer than a gap apart (e.g. two connectors leaving the same
  // card) into a single break so they don't overlap into a glitch
  const merged = [];
  ys.forEach((y) => { if (!merged.length || y - merged[merged.length - 1] > gap) merged.push(y); });
  return merged;
}

// Build an SVG path for an orthogonal point list, breaking each vertical segment
// with a `2*gap` gap at every horizontal crossing. Horizontal segments stay solid.
export function gappedPath(pts, horizontals, gap = 4) {
  let d = `M ${pts[0][0]},${pts[0][1]}`;
  for (let i = 0; i < pts.length - 1; i += 1) {
    const [x1, y1] = pts[i]; const [x2, y2] = pts[i + 1];
    if (x1 === x2 && y1 !== y2) {
      const down = y2 > y1;
      crossingYs(x1, y1, y2, horizontals, gap).forEach((cy) => {
        d += ` L ${x1},${down ? cy - gap : cy + gap}`;
        d += ` M ${x1},${down ? cy + gap : cy - gap}`;
      });
    }
    d += ` L ${x2},${y2}`;
  }
  return d;
}
